import React from 'react'
import { createRoot } from 'react-dom/client'
import WelcomeModal from '../Login/Modules/WelcomeModal.jsx'
import AlertBanner from './AlertBanner.jsx'
import TimeoutBanner from './TimeoutBanner.jsx'

export function showAlertBanner({ status, title, text, sticky, displayTime }) {
  const nodeId = 'popup' + Math.ceil(Math.random() * 1000000)
  const node = document.createElement('div')
  node.setAttribute('id', nodeId)
  const alertBannerNode = document.getElementById('alert-banner')
  alertBannerNode.appendChild(node)
  if (alertBannerNode.childNodes.length <= 1) {
    createRoot(node).render(
      <AlertBanner
        status={status}
        title={title}
        text={text}
        sticky={sticky}
        displayTime={displayTime}
      />
    )
  } else {
    console.log('Alert banner child already exists. Not rendering another one.')
  }
}

export function showWelcomeBanner({ mode, profileData }) {
  const nodeId = 'popup' + Math.ceil(Math.random() * 1000000)

  const node = document.createElement('div')
  node.id = nodeId
  const alertBannerNode = document.getElementById('alert-banner')

  alertBannerNode.appendChild(node)

  const container = document.getElementById(nodeId)
  const root = createRoot(container)

  root.render(<WelcomeModal mode={mode} profileData={profileData} />)
}

const timeoutNodeId = 'popup' + Math.ceil(Math.random() * 1000000)
export function showTimeoutBanner(
  durationInMinutes,
  closedClicked,
  onTimeComplete
) {
  const node = document.createElement('div')
  node.id = timeoutNodeId
  const alertBannerNode = document.getElementById('alert-banner')

  alertBannerNode.appendChild(node)

  const container = document.getElementById(timeoutNodeId)
  const root = createRoot(container)

  root.render(
    <TimeoutBanner
      durationInMinutes={durationInMinutes}
      closeClicked={closedClicked}
      onTimeComplete={onTimeComplete}
    />
  )
}

export function removeTimeoutBanner() {
  const container = document.getElementById(timeoutNodeId)
  const root = createRoot(container)
  root.unmount()
}
